import React, { useMemo } from 'react';

import { HStack, Text } from '@rtkwlf/fenrir-react';
import type { CcAgent } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { LogoBadge } from '@features/tickets/components/logo-badge/logo-badge';
import { Tooltip } from 'ae-components/tooltip/tooltip';

export type CcAgentCellProps = {
  value: CcAgent[] | undefined;
};

export const CcAgentCell: React.FC<CcAgentCellProps> = ({ value = [] }) => {
  const { t } = useTranslation();
  const valueLength = value.length;

  const ccTooltip = useMemo(() => {
    if (valueLength < 2) {
      return null;
    }

    return (
      <Tooltip
        tooltip={
          valueLength > 1 ? value.map(({ name }) => name).join(', ') : ''
        }
        tooltipContentProps={{
          maxWidth: 'prose',
          side: 'top',
        }}
      >
        <Text styledAs="body5" textDecoration="underline" whiteSpace="nowrap">
          {`${valueLength - 1} ${t('ui:more')}`}
        </Text>
      </Tooltip>
    );
  }, [t, value, valueLength]);

  if (!valueLength) {
    return null;
  }

  return (
    <HStack gap="zero">
      <Text styledAs="body3" whiteSpace="nowrap">
        <LogoBadge text={value[0].name} showLogo={value[0].isAgent} />
      </Text>
      {ccTooltip}
    </HStack>
  );
};
